"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/* eslint-disable camelcase */
var invariant_1 = __importDefault(require("invariant"));
var logs_1 = require("@ledgerhq/logs");
var url_1 = __importDefault(require("url"));
var errors_1 = require("@ledgerhq/errors");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var package_json_1 = require("../../package.json");
var socket_1 = require("./socket");
var socket_mock_1 = require("./socket.mock");
var semver_1 = __importDefault(require("semver"));
var network_1 = __importDefault(require("../network"));
var env_1 = require("../env");
var cache_1 = require("../cache");
var user_1 = require("../user");
var provider_1 = require("../manager/provider");
var remapSocketError = function (context) {
    return (0, operators_1.catchError)(function (e) {
        if (!e || !e.message)
            return (0, rxjs_1.throwError)(e);
        if (e.message.startsWith("invalid literal")) {
            // hack to detect the case you're not in good condition (not in dashboard)
            return (0, rxjs_1.throwError)(new errors_1.DeviceOnDashboardExpected());
        }
        var status = e instanceof errors_1.TransportStatusError
            ? // @ts-expect-error TransportStatusError to be typed on ledgerjs
                e.statusCode.toString(16)
            : e.message.slice(e.message.length - 4);
        switch (status) {
            case "6a80":
            case "6a81":
            case "6a8e":
            case "6a8f":
                return (0, rxjs_1.throwError)(new errors_1.ManagerAppAlreadyInstalledError());
            case "6982":
            case "5303":
                return (0, rxjs_1.throwError)(new errors_1.ManagerDeviceLockedError());
            case "6a84":
            case "5103":
                if (context === "firmware" || context === "mcu") {
                    return (0, rxjs_1.throwError)(new errors_1.ManagerFirmwareNotEnoughSpaceError());
                }
                return (0, rxjs_1.throwError)(new errors_1.ManagerNotEnoughSpaceError());
            case "6a85":
            case "5102":
                if (context === "firmware" || context === "mcu") {
                    return (0, rxjs_1.throwError)(new errors_1.UserRefusedFirmwareUpdate());
                }
                return (0, rxjs_1.throwError)(new errors_1.ManagerNotEnoughSpaceError());
            case "6985":
            case "5501":
                if (context === "firmware" || context === "mcu") {
                    return (0, rxjs_1.throwError)(new errors_1.UserRefusedFirmwareUpdate());
                }
                return (0, rxjs_1.throwError)(new errors_1.ManagerNotEnoughSpaceError());
            default:
                return (0, rxjs_1.throwError)(e);
        }
    });
};
var applicationsByDevice = (0, cache_1.makeLRUCache)(function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var r;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "POST",
                    url: url_1["default"].format({
                        pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/get_apps"),
                        query: {
                            livecommonversion: package_json_1.version
                        }
                    }),
                    data: params
                })];
            case 1:
                r = _a.sent();
                return [2 /*return*/, r.data.application_versions];
        }
    });
}); }, function (p) {
    return "".concat(p.provider, "_").concat(p.current_se_firmware_final_version, "_").concat(p.device_version);
});
var listApps = (0, cache_1.makeLRUCache)(function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "GET",
                    url: url_1["default"].format({
                        pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/applications"),
                        query: {
                            livecommonversion: package_json_1.version
                        }
                    })
                })];
            case 1:
                data = (_a.sent()).data;
                if (!data || !Array.isArray(data)) {
                    throw new errors_1.NetworkDown("");
                }
                return [2 /*return*/, data];
        }
    });
}); }, function () { return ""; });
var listCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
    var r;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "GET",
                    url: url_1["default"].format({
                        pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/categories"),
                        query: {
                            livecommonversion: package_json_1.version
                        }
                    })
                })];
            case 1:
                r = _a.sent();
                return [2 /*return*/, r.data];
        }
    });
}); };
var getMcus = (0, cache_1.makeLRUCache)(function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "GET",
                    url: url_1["default"].format({
                        pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/mcu_versions"),
                        query: {
                            livecommonversion: package_json_1.version
                        }
                    })
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); }, function () { return ""; });
var compatibleMCUForDeviceInfo = function (mcus, deviceInfo, provider) {
    return mcus.filter(function (m) {
        return (deviceInfo.majMin === m.from_bootloader_version ||
            deviceInfo.version === m.from_bootloader_version) &&
            m.providers.includes(provider);
    });
};
var findBestMCU = function (compatibleMCU) {
    var best = compatibleMCU[0];
    for (var i = 1; i < compatibleMCU.length; i++) {
        if (semver_1["default"].gt(semver_1["default"].coerce(compatibleMCU[i].name) || "", semver_1["default"].coerce(best.name) || "")) {
            best = compatibleMCU[i];
        }
    }
    return best;
};
var getLanguagePackagesForDevice = function (deviceInfo) { return __awaiter(void 0, void 0, void 0, function () {
    var deviceVersion, seFirmwareVersion, data, allPackages, packages;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getDeviceVersion(deviceInfo.targetId, (0, provider_1.getProviderId)(deviceInfo))];
            case 1:
                deviceVersion = _a.sent();
                return [4 /*yield*/, getCurrentFirmware({
                        version: deviceInfo.version,
                        deviceId: deviceVersion.id,
                        provider: (0, provider_1.getProviderId)(deviceInfo)
                    })];
            case 2:
                seFirmwareVersion = _a.sent();
                return [4 /*yield*/, (0, network_1["default"])({
                        method: "GET",
                        url: url_1["default"].format({
                            pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/language-package"),
                            query: {
                                livecommonversion: package_json_1.version
                            }
                        })
                    })];
            case 3:
                data = (_a.sent()).data;
                allPackages = data.reduce(function (acc, response) { return __spreadArray(__spreadArray([], __read(acc), false), __read(response.language_package_version.map(function (p) { return (__assign(__assign({}, p), { language: response.language })); })), false); }, []);
                packages = allPackages.filter(function (pack) {
                    return pack.device_versions.includes(deviceVersion.id) &&
                        pack.se_firmware_final_versions.includes(seFirmwareVersion.id);
                });
                return [2 /*return*/, packages];
        }
    });
}); };
var getLatestFirmware = (0, cache_1.makeLRUCache)(function (_a) {
    var current_se_firmware_final_version = _a.current_se_firmware_final_version, device_version = _a.device_version, provider = _a.provider;
    return __awaiter(void 0, void 0, void 0, function () {
        var salt, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    salt = (0, user_1.getUserHashes)().firmwareSalt;
                    return [4 /*yield*/, (0, network_1["default"])({
                            method: "POST",
                            url: url_1["default"].format({
                                pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/get_latest_firmware"),
                                query: {
                                    livecommonversion: package_json_1.version,
                                    salt: salt
                                }
                            }),
                            data: {
                                current_se_firmware_final_version: current_se_firmware_final_version,
                                device_version: device_version,
                                provider: provider
                            }
                        })];
                case 1:
                    data = (_b.sent()).data;
                    if (data.result === "null") {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, data.se_firmware_osu_version];
            }
        });
    });
}, function (a) {
    return "".concat(a.current_se_firmware_final_version, "_").concat(a.device_version, "_").concat(a.provider);
});
var getCurrentOSU = (0, cache_1.makeLRUCache)(function (input) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "POST",
                    url: url_1["default"].format({
                        pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/get_osu_version"),
                        query: {
                            livecommonversion: package_json_1.version
                        }
                    }),
                    data: {
                        device_version: input.deviceId,
                        version_name: "".concat(input.version, "-osu"),
                        provider: input.provider
                    }
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); }, function (a) { return "".concat(a.version, "_").concat(a.deviceId, "_").concat(a.provider); });
var getCurrentFirmware = (0, cache_1.makeLRUCache)(function (input) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "POST",
                    url: url_1["default"].format({
                        pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/get_firmware_version"),
                        query: {
                            livecommonversion: package_json_1.version
                        }
                    }),
                    data: {
                        device_version: input.deviceId,
                        version_name: input.version,
                        provider: input.provider
                    }
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); }, function (a) { return "".concat(a.version, "_").concat(a.deviceId, "_").concat(a.provider); });
var getFinalFirmwareById = (0, cache_1.makeLRUCache)(function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "GET",
                    url: url_1["default"].format({
                        pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/firmware_final_versions/").concat(id),
                        query: {
                            livecommonversion: package_json_1.version
                        }
                    })
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); }, function (id) { return String(id); });
var getDeviceVersion = (0, cache_1.makeLRUCache)(function (targetId, provider) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "POST",
                    url: url_1["default"].format({
                        pathname: "".concat((0, env_1.getEnv)("MANAGER_API_BASE"), "/get_device_version"),
                        query: {
                            livecommonversion: package_json_1.version
                        }
                    }),
                    data: {
                        provider: provider,
                        target_id: targetId
                    }
                })["catch"](function (error) {
                    var status = error && (error.status || (error.response && error.response.status)); // FIXME LLD is doing error remapping already. we probably need to move the remapping in live-common
                    if (status === 404) {
                        throw new errors_1.FirmwareNotRecognized("manager api did not recognize targetId=" + targetId, {
                            targetId: targetId
                        });
                    }
                    throw error;
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); }, function (targetId, provider) { return "".concat(targetId, "_").concat(provider); });
var install = function (transport, context, params, unresponsiveExpectedDuringBulk) {
    if ((0, env_1.getEnv)("MOCK")) {
        return (0, socket_mock_1.createMockSocket)((0, socket_mock_1.secureChannelMock)(true), (0, socket_mock_1.bulkSocketMock)(3000));
    }
    (0, logs_1.log)("manager", "install " + context, params);
    return (0, socket_1.createDeviceSocket)(transport, {
        url: url_1["default"].format({
            pathname: "".concat((0, env_1.getEnv)("BASE_SOCKET_URL"), "/install"),
            query: __assign(__assign({}, params), { livecommonversion: package_json_1.version })
        }),
        unresponsiveExpectedDuringBulk: unresponsiveExpectedDuringBulk
    }).pipe(remapSocketError(context));
};
var genuineCheck = function (transport, _a) {
    var targetId = _a.targetId, perso = _a.perso;
    if ((0, env_1.getEnv)("MOCK")) {
        return (0, socket_mock_1.createMockSocket)((0, socket_mock_1.secureChannelMock)(false), (0, socket_mock_1.resultMock)("0000"));
    }
    (0, logs_1.log)("manager", "genuineCheck", {
        targetId: targetId,
        perso: perso
    });
    return (0, socket_1.createDeviceSocket)(transport, {
        url: url_1["default"].format({
            pathname: "".concat((0, env_1.getEnv)("BASE_SOCKET_URL"), "/genuine"),
            query: {
                targetId: targetId,
                perso: perso,
                livecommonversion: package_json_1.version
            }
        })
    }).pipe((0, operators_1.map)(function (e) {
        if (e.type === "result") {
            return {
                type: "result",
                payload: String(e.payload || "")
            };
        }
        return e;
    }));
};
var listInstalledApps = function (transport, _a) {
    var targetId = _a.targetId, perso = _a.perso;
    if ((0, env_1.getEnv)("MOCK")) {
        var result = global._listInstalledApps_mock_result;
        (0, invariant_1["default"])(result, "using MOCK, global._listInstalledApps_mock_result must be set");
        return (0, socket_mock_1.createMockSocket)((0, socket_mock_1.secureChannelMock)(false), (0, socket_mock_1.resultMock)(result));
    }
    (0, logs_1.log)("manager", "listInstalledApps", {
        targetId: targetId,
        perso: perso
    });
    return (0, socket_1.createDeviceSocket)(transport, {
        url: url_1["default"].format({
            pathname: "".concat((0, env_1.getEnv)("BASE_SOCKET_URL"), "/apps/list"),
            query: {
                targetId: targetId,
                perso: perso,
                livecommonversion: package_json_1.version
            }
        })
    }).pipe(remapSocketError("listInstalledApps"), (0, operators_1.map)(function (o) {
        if (o.type === "result") {
            return {
                type: "result",
                payload: __spreadArray([], __read(o.payload), false).map(function (a) {
                    (0, invariant_1["default"])(typeof a === "object" && a, "payload array item are objects");
                    var hash = a.hash, name = a.name;
                    (0, invariant_1["default"])(typeof hash === "string", "hash is defined");
                    (0, invariant_1["default"])(typeof name === "string", "name is defined");
                    return {
                        hash: hash,
                        name: name
                    };
                })
            };
        }
        return o;
    }));
};
var installMcu = function (transport, context, _a) {
    var targetId = _a.targetId, version = _a.version;
    if ((0, env_1.getEnv)("MOCK")) {
        return (0, socket_mock_1.createMockSocket)((0, socket_mock_1.secureChannelMock)(false), (0, socket_mock_1.bulkSocketMock)(5000));
    }
    (0, logs_1.log)("manager", "installMCU " + context, {
        targetId: targetId,
        version: version
    });
    return (0, socket_1.createDeviceSocket)(transport, {
        url: url_1["default"].format({
            pathname: "".concat((0, env_1.getEnv)("BASE_SOCKET_URL"), "/mcu"),
            query: {
                targetId: targetId,
                version: version,
                livecommonversion: package_json_1.version
            }
        }),
        unresponsiveExpectedDuringBulk: true
    }).pipe(remapSocketError(context));
};
var API = {
    applicationsByDevice: applicationsByDevice,
    listApps: listApps,
    listInstalledApps: listInstalledApps,
    listCategories: listCategories,
    getMcus: getMcus,
    getLanguagePackagesForDevice: getLanguagePackagesForDevice,
    getLatestFirmware: getLatestFirmware,
    getCurrentOSU: getCurrentOSU,
    compatibleMCUForDeviceInfo: compatibleMCUForDeviceInfo,
    findBestMCU: findBestMCU,
    getCurrentFirmware: getCurrentFirmware,
    getFinalFirmwareById: getFinalFirmwareById,
    getDeviceVersion: getDeviceVersion,
    install: install,
    genuineCheck: genuineCheck,
    installMcu: installMcu
};
exports["default"] = API;
//# sourceMappingURL=Manager.js.map